export const printPageStyle = `
            @page {
                size: A4;
                margin: 15mm;
            }
            @media print {
                body {
                    margin: 0;
                    padding: 0;
                }
                .print-only {
                    position: static !important;
                    left: 0 !important;
                    top: 0 !important;
                    width: 100% !important;
                    display: block !important;
                    visibility: visible !important;
                }
                .print-only * {
                    visibility: visible !important;
                    color: inherit !important;
                }
                /* Ensure any runtime loading overlays are hidden in print */
                .image-node.loading,
                img.loading {
                    filter: none !important;
                    opacity: 100% !important;
                }
                .image-node.loading::before,
                .image-node.loading::after {
                    content: none !important;
                    display: none !important;
                }
            }
        `
